/**
 * A waiver's words with the names in — the same filling the API does
 * (services/api/src/people/waiver-text.ts).
 *
 * What this returns is sent with the tick and compared on the server, so the
 * two must agree to the character. If they ever drift the API refuses the
 * signature (waiver_changed) rather than recording words nobody saw.
 *
 * {adult} (036) is an adult signing for themselves: their own name.
 */
export function fillWaiver(template: string, guardian: string, athlete: string): string {
  return template.replaceAll('{guardian}', guardian).replaceAll('{athlete}', athlete).replaceAll('{adult}', athlete);
}
